/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiProbabilityPickerItem from './UiProbabilityPickerItem'

interface UiProbabilityPickerItemsListProps {
    percentages: number[]
    onSelect: (value: number) => void
    getProbColor: (value: number) => string
}

const UiProbabilityPickerItemsList = (
    props: UiProbabilityPickerItemsListProps
) => {
    return (
        <div className="UiProbabilityPickerItemsList">
            {props.percentages.map((p) => (
                <UiProbabilityPickerItem
                    key={p}
                    p={p}
                    onClick={() => props.onSelect(p)}
                    colorClass={props.getProbColor(p)}
                />
            ))}
        </div>
    )
}

export default UiProbabilityPickerItemsList
